<script setup>
  import { computed } from 'vue'

  const props = defineProps({
    severity: {
      type: String,
      default: 'info',
      validator: value => ['info', 'error'].includes(value),
    },
  })

  const severityClass = computed(() => {
    return {
      'custom-modal-dialog-info': props.severity === 'info',
      'custom-modal-dialog-error': props.severity === 'error',
    }
  })
</script>

<template>
  <Dialog v-bind="$attrs" class="custom-modal-dialog" :class="severityClass" position="top">
    <template v-for="(_, name) of $slots" :key="name" #[name]="slotData">
      <slot :name="name" v-bind="slotData" />
    </template>
  </Dialog>
</template>

<style lang="scss">
  .custom-modal-dialog {
    border: none;
    border-radius: 8px;
    margin-top: 50px;
  }

  .custom-modal-dialog .p-dialog-header {
    --p-dialog-header-padding: 0.5rem 1rem;

    background: var(--fm-ui-primary-color);
    color: #fff;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;

    .p-dialog-close-button:hover {
      background: rgba(255, 255, 255, 0.25);
    }
  }

  .custom-modal-dialog .p-dialog-footer {
    border-top: 1px solid light-dark(#f5f8fa, #2b2f33);
    justify-content: start;
    display: block;
    padding-top: 1rem;
  }

  .custom-modal-dialog .p-dialog-content {
    --p-dialog-content-padding: 1rem;
  }

  .custom-modal-dialog-error {
    .p-dialog-header {
      background: var(--fm-ui-red-color);
    }
  }

  .custom-modal-dialog .p-dialog-header .p-button-text.p-button-secondary {
    color: #fff !important;
  }
</style>
